import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';

import LoadingSpinner from 'components/loading-spinner';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';
import { ReadOnlyBox } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/styled-components';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.feedInventoryTab';

interface Props {
  isDialog: boolean;
}

const FeedInventory: React.FC<Props> = ({ isDialog }) => {
  const {
    getOfdSettingsQuery: { data: ofdSettings, isFetching: isOfdSettingsFetching },
  } = useInputSettingsState();

  const lastManualUpdate = (dateString: string): any => {
    return dayjs().diff(dayjs(dateString), 'day');
  };

  if (isOfdSettingsFetching) return <LoadingSpinner />;

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      {isDialog && (
        <Typography variant="body1">
          <FormattedMessage id={`${PAGE_NAME_ID}.headerText`} />
        </Typography>
      )}
      <ReadOnlyBox>
        <Box display={'flex'} gap={2}>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            <FormattedNumber
              value={ofdSettings?.inventoryExplanation.startingInventory ?? 0}
              unit={'kilogram'}
              style="unit"
              minimumFractionDigits={0}
              maximumFractionDigits={0}
            />
          </Typography>
          <Typography variant="h3">
            <FormattedMessage
              id={`${PAGE_NAME_ID}.percentage`}
              values={{
                percentage: (
                  <FormattedNumber
                    value={(ofdSettings?.inventoryExplanation.startingPercentOfCapacity ?? 0) * 100}
                    unit={'percent'}
                    style="unit"
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                  />
                ),
              }}
            />
          </Typography>
        </Box>
      </ReadOnlyBox>
      <Typography variant="body1" color={'#415965'}>
        <FormattedMessage id={`${PAGE_NAME_ID}.lastUpdated`} />
        <FormattedDate value={ofdSettings?.manualInventory?.updatedDate} day="2-digit" month="short" year="numeric" /> (
        {lastManualUpdate(ofdSettings?.manualInventory?.updatedDate as string)} <FormattedMessage id={`${PAGE_NAME_ID}.daysAgo`} />)
      </Typography>
    </Box>
  );
};

export default FeedInventory;
